import { useMemo } from "react";

export const useSize = (size: string, S: { [key: string]: string }) => {
    const sizeClass = useMemo(() => {
        switch (size) {
            case "VIDEO_SIZE_SMALL":
                return S.sizeSmall;
            case "VIDEO_SIZE_MEDIUM":
                return S.sizeMedium;
            default:
                return S.sizeLarge;
        }
    }, [size, S]);

    return {
        sizeClass,
    };
};
